import { useAppSelector } from 'hooks/reduxHooks'
import useExperiment from 'hooks/Experiments/useExperiment'
import { Experiments } from 'constants/experiments'
import type { FunnelEvaluationMetadata } from 'checkout/selectors/funnel'
import { getFunnelFeatures, getFunnelEvaluationMetadata } from 'checkout/selectors/funnel'

export function useFunnelFeature(feature: keyof App.FunnelFeatureToggles): boolean {
  return useAppSelector(getFunnelFeatures)[feature]
}

/**
 * Hook to get the funnel evaluation metadata (ruleId, ruleName, outcome).
 * Useful for debugging, analytics, or displaying which rule was applied.
 */
export function useFunnelEvaluationMetadata(): FunnelEvaluationMetadata {
  return useAppSelector(getFunnelEvaluationMetadata)
}

/**
 * Triggers the Optimizely experiment for a matched funnel rule.
 * This ensures activation only happens for users who meet the rule criteria.
 */
export function useFunnelOptimiserExperimentTrigger(): void {
  const { ruleId, outcome } = useFunnelEvaluationMetadata()
  const canTrigger = outcome === 'matched'

  useExperiment(Experiments.funnelOptimiserRuleId16, { canActivate: canTrigger && ruleId === 16 })
  useExperiment(Experiments.funnelOptimiserRuleId17, { canActivate: canTrigger && ruleId === 17 })
  useExperiment(Experiments.funnelOptimiserRuleId18, { canActivate: canTrigger && ruleId === 18 })
}
